import { types } from 'utils';

export const geocode = async (lat: number, lng: number) => {
	try {
		const geocoder = new (window as any).google.maps.Geocoder();
		const { results } = await geocoder.geocode({ location: { lat, lng } });
		return results;
	} catch (error) {
		return { status: 606, message: 'Network request failed', error };
	}
};

export const autocomplete = async (input: string): Promise<types.Address[]> => {
	try {
		const { suggestions } = await (
			window as any
		).google.maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions({
			input,
			// types: ['address'],
			includedRegionCodes: ['ng', 'gh'],
		});
		return (suggestions || []).map((s: any) => {
			return {
				id: s.placePrediction.placeId,
				name: s.placePrediction.text.text,
			};
		}) as types.Address[];
	} catch (error) {
		return [];
	}
};

export const placeDetails = async (
	placeId: string
): Promise<types.Address | null> => {
	try {
		const place = new (window as any).google.maps.places.Place({
			id: placeId,
		});
		await place.fetchFields({
			fields: [
				'displayName',
				'location',
				'formattedAddress',
				'addressComponents',
				'businessStatus',
			],
		});
		return addressComponents({
			name: place.displayName,
			formatted_address: place.formattedAddress,
			business_status: place.businessStatus,
			geometry: place.location ? { location: place.location } : undefined,
			address_components: (place.addressComponents || []).map((c: any) => ({
				long_name: c.longText,
				short_name: c.shortText,
				types: c.types,
			})),
		});
	} catch (error) {
		return null;
	}
};

export const addressComponents = (plc: any): types.Address | null => {
	if (!plc || !plc.geometry || !plc.address_components) return null;
	const isNotHome = typeof plc.business_status !== 'undefined';
	const findComponentName = (
		type: string,
		key: 'short_name' | 'long_name' = 'long_name'
	) => {
		const name: string =
			((plc.address_components || []).find((pa: any) =>
				(pa.types || []).includes(type)
			) || {})[key] || '';
		return name;
	};
	return {
		x:
			typeof plc.geometry?.location?.lat === 'number'
				? plc.geometry?.location?.lat
				: plc.geometry?.location?.lat(),
		y:
			typeof plc.geometry?.location?.lng === 'number'
				? plc.geometry?.location?.lng
				: plc.geometry?.location?.lng(),
		iso: findComponentName('country', 'short_name'),
		city: findComponentName('locality'),
		name: `${plc.name ? `${plc.name}, ` : ''}${plc.formatted_address ? plc.formatted_address.replace(`${plc.name}, `, ``) : ''}`,
		state: findComponentName('administrative_area_level_1'),
		street: findComponentName('route') || findComponentName('neighborhood'),
		country: findComponentName('country'),
		houseNo: findComponentName('street_number') || (isNotHome ? '69' : ''),
		timeZone: '',
		zoom: 15,
	};
};

export const myCurrentLocation = (): Promise<types.Address | null> => {
	return new Promise((resolve) => {
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(
				(position: GeolocationPosition) => {
					const pos = {
						lat: position.coords.latitude,
						lng: position.coords.longitude,
					};
					geocode(pos.lat, pos.lng).then((geoc) => {
						resolve(addressComponents(geoc?.[0]));
					});
				},
				(e) => {
					console.log(e);
				}
			);
		} else {
			resolve(null);
		}
	});
};
